import { Button, Text } from "@softmax/design-system";
import { colors, spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { useRef } from "react";

type MediaImageInputProps = Readonly<{
  itemCount: number;
  maxItems: number;
  disabled: boolean;
  uploadingImage: boolean;
  onImageFile(file: File): void;
}>;

export function MediaImageInput({
  itemCount,
  maxItems,
  disabled,
  uploadingImage,
  onImageFile,
}: MediaImageInputProps) {
  const imageInput = useRef<HTMLInputElement>(null);
  return (
    <div {...stylex.props(styles.divider)}>
      <Text size="small" tone="muted">
        {itemCount}/{maxItems} items
      </Text>
      <Button
        size="sm"
        disabled={disabled}
        onClick={() => imageInput.current?.click()}
      >
        {uploadingImage ? "Uploading…" : "Upload image"}
      </Button>
      <input
        ref={imageInput}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        disabled={disabled}
        {...stylex.props(styles.hidden)}
        onChange={(event) => {
          const file = event.target.files?.[0];

          if (file) onImageFile(file);

          event.target.value = "";
        }}
      />
    </div>
  );
}

const styles = stylex.create({
  divider: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: spacing.space12,
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: colors.border,
    paddingTop: spacing.space10,
  },
  hidden: { display: "none" },
});
